import React, { Component } from "react";
import axios from "axios";

import { Input, Button } from "mdbreact";
import domain from ".././../../../domain";

import { Row, Col, Card, CardBody, CardTitle } from "mdbreact";

//import { Icon,Row} from 'react-materialize'
class AddTraineeById extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      designation: "",
      organization: "",
      city: "",
      tstate: "",
      address: " ",
      department: "",
      email: "",
      mobile: "",
      gender: " ",
      course: " ",
      loading: true,
      error: "",
      data: null,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    //this.focus = this.focus.bind(this);
  }
  // focus() {
  //   this.textInput.focus();
  // }
  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    console.log(e.target.name + "" + e.target.value);
  };

  componentDidMount() {
    console.log("here");
    let courseId = this.props.match.params.id;
    axios
      .get(`${domain.DBServer}/fetch-course/${courseId}`)
      .then((result) => {
        console.log(result);
        this.setState({
          data: result.data,
          loading: false,
          error: false,
        });
      })
      .catch((error) => {
        console.error("error: ", error);
        this.setState({
          error: `${error}`,
          loading: false,
        });
      });
  }

  addParticipant(newParticipant) {
    console.log(newParticipant);
    axios
      .request({
        method: "post",
        url: `${domain.DBServer}/add-trainee`,
        data: newParticipant,
      })
      .then((response) => {
        console.log(response);
        //console.log(response)
        const { err, success, msg } = response.data;

        //console.log(success+msg+err)
        console.log(success);
        console.log(err);

        if (success) {
          let courseId = this.props.match.params.id;
          alert(msg);
          //console.log(this)
          this.props.history.push(`/view-trainees_edit/${courseId}`);
        } else {
          console.log("else");
          alert(msg);
          document.getElementsByClassName("mobileField")[0].focus();
          return false;
        }
      })
      .catch((err) => console.log(err));
  }

  onSubmit(e) {
    e.preventDefault();

    const newParticipant = {
      TraineeName: this.state.name,
      City: this.state.city,
      address: this.state.address,
      Designation: this.state.designation,
      Organization: this.state.organization,
      State: this.state.tstate,
      Email: this.state.email,
      Mobile: this.state.mobile,
      Department: this.state.department,
      course_id: this.props.match.params.id,
      gender: this.state.gender,
    };
    let r = window.confirm("Check once again the details before submitting");
    if (r) {
      this.addParticipant(newParticipant);
    } else {
      return false;
    }
  }

  intialValues = (e) => {
    //  alert(e.target.name)
    this.setState({
      name: "",
      designation: "",
      organization: "",
      city: "",
      tstate: "",
      address: " ",
      department: "",
      email: "",
      mobile: "",
      gender: " ",
      course: " ",
    });
  };

  render() {
    const { loading, error, data } = this.state;
    if (loading) {
      return <p>Loading ...</p>;
    }
    if (error) {
      return (
        <h4>
          There was no ongoing courses .
          {/* <button onClick={this.loadData}>Try again</button> */}
        </h4>
      );
    }
    return (
      <div>
        <br />
        <Row className="justify-content-md-center">
          <Col md="6">
            <Card>
              <CardBody>
                {/* <Link className="btn grey" to="/Home">Back</Link> */}
                <br />
                <br />
                <CardTitle>
                  <h3 style={{ textAlign: "center", color: "blue" }}>
                    Add Trainee
                  </h3>
                </CardTitle>
                <hr />
                <form onSubmit={this.onSubmit.bind(this)}>
                  <div className="row">
                    <label for="course" className="grey-text">
                      Choose Course
                    </label>
                    <select
                      className="form-control"
                      id="course"
                      name="course"
                      onChange={this.handleInputChange}
                    >
                      {data.map((course) => (
                        <option
                          key={course.course_id}
                          value={course.course_id}
                          onChange={this.handleInputChange}
                        >
                          {course.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <Input
                        label="Trainee Name"
                        value={this.state.name}
                        id="name"
                        name="name"
                        group
                        type="text"
                        validate
                        onChange={this.handleInputChange}
                        required="required"
                      />
                    </div>
                    <div className="col-md-4">
                      <Input
                        label="Organization"
                        value={this.state.organization}
                        id="organization"
                        name="organization"
                        group
                        type="text"
                        validate
                        onChange={this.handleInputChange}
                        required="required"
                      />
                    </div>
                    <div className="col-md-4">
                      <Input
                        label="Designation"
                        value={this.state.designation}
                        id="designation"
                        name="designation"
                        group
                        type="text"
                        validate
                        onChange={this.handleInputChange}
                        required="required"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <Input
                        type="textarea"
                        label="Address"
                        value={this.state.address}
                        id="address"
                        name="address"
                        group
                        validate
                        onChange={this.handleInputChange}
                        required="required"
                      />
                    </div>
                    <div className="col-md-4">
                      <Input
                        label="City"
                        id="city"
                        name="city"
                        value={this.state.city}
                        group
                        type="text"
                        validate
                        onChange={this.handleInputChange}
                        required="required"
                      />
                    </div>
                    <div className="col-md-4">
                      <Input
                        label="State"
                        id="tstate"
                        name="tstate"
                        value={this.state.tstate}
                        group
                        type="text"
                        validate
                        onChange={this.handleInputChange}
                        required="required"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <Input
                        label="Email"
                        id="email"
                        name="email"
                        value={this.state.email}
                        group
                        type="email"
                        validate
                        onChange={this.handleInputChange}
                        required="required"
                      />
                    </div>
                    <div className="col-md-4">
                      <Input
                        label="Mobile"
                        id="tel"
                        className="mobileField"
                        value={this.state.mobile}
                        name="mobile"
                        group
                        type="tel"
                        validate
                        pattern="[0-9]{10}"
                        onChange={this.handleInputChange}
                        required="required"
                      />
                    </div>
                    <div className="col-md-4">
                      <Input
                        label="Department"
                        id="department"
                        value={this.state.department}
                        name="department"
                        group
                        type="text"
                        validate
                        onChange={this.handleInputChange}
                        required="required"
                        ref={(input) => {
                          this.textInput = input;
                        }}
                      />
                    </div>
                  </div>
                  <fieldset className="form-group">
                    <div className="row">
                      <legend className="col-form-label col-sm-2 pt-0">
                        Gender
                      </legend>
                      <div className="col-sm-10">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="gender1"
                            value="Male"
                            onChange={this.handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="gender1">
                            Male
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="gender2"
                            value="Female"
                            onChange={this.handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="gender2">
                            Female
                          </label>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <Button type="submit">Save</Button> &nbsp;&nbsp;
                  <Button type="reset" name="clear" onClick={this.intialValues}>
                    Clear
                  </Button>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default AddTraineeById;
